<template>
  <div>
    <div class="cart-detail-box">
      <h6 class="title">{{ _T(title) }}</h6>
      <UserAddress v-if="order_type === CONST.ORDER_TYPE_ONLINE"></UserAddress>
      <div
        class="modalbody ratio_portrait"
        v-if="order_type === CONST.ORDER_TYPE_TAKEAWAY"
      >
        <select-delivery-area-form ref="selectDAForm" />
      </div>
    </div>
    <!--<div class="cart-detail-box">
      &lt;!&ndash;      <h6 class="title">{{ _T('Deliver time') }}</h6>&ndash;&gt;
      &lt;!&ndash;<delivery-time />&ndash;&gt;
      &lt;!&ndash;<div class="delivery-detail d-block">
       &lt;!&ndash; <ul>
          <li>
            <svg width="20" height="21" fill="none">
              <use class="fill-tertiary" xlink:href="#OutlineCalender" />
            </svg>
            <span>{{ _T('Will delivery soon') }}</span>
          </li>
        </ul>&ndash;&gt;
        &lt;!&ndash;<ul>
          <li>
            <svg width="20" height="21" fill="none">
              <use class="fill-tertiary" xlink:href="#OutlineCalender" />
            </svg>
            <span>Thu, 19 Jan 2019</span>
          </li>
          <li>
            <svg width="18" height="17" fill="none">
              <use class="fill-tertiary" xlink:href="#time" />
            </svg>
            <span>5.00 pm</span>
          </li>
        </ul>
        <button
          type="button"
          class="btn btn-solid btn-change"
          v-b-modal.DeliveryTime
          @click="showModal"
          data-toggle="modal"
        >
          {{ _T('Change') }}
        </button>&ndash;&gt;

      </div>&ndash;&gt;
    </div>-->
  </div>
</template>

<script>
import UserAddress from '@/components/Blocks/Payment/UserAddress'
import selectDeliveryAreaForm from '@/components/SelectDeliveryAreaForm'
import * as CONST from '@/constants'

import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryDetail',
  components: {
    UserAddress,
    selectDeliveryAreaForm,
  },
  data() {
    return {
      openDeliveryarea: false,
      isModalVisible: false,
    }
  },
  watch: {
    mobileCartIsOpened: function(newVal) {
      if (newVal == true) {
        this.processMobileCartIsOpened()
      }
    },
  },
  computed: {
    title() {
      if (this.order_type === CONST.ORDER_TYPE_ONLINE) {
        return 'Deliver to'
      } else {
        return 'Receive from'
      }
    },
    selectedAddress: {
      get() {
        return this.$store.state.customer_store.selectedAddress
      },
      set(val) {
        this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', val, {
          root: true,
        })
      },
    },
    ...mapGetters([
      '_T',
      'customer_addresses',
      'customerPosition',
      'customer_addresses_by_store_id',
      'brandStoreRoute',
      'mobileCartIsOpened',
      'order_type',
    ]),
  },
  mounted() {
    this.$store.dispatch('load_customer', true)
  },
  methods: {
    processMobileCartIsOpened() {
      let storeId = this.$route.params.store_id
      var cust_addresses_by_store_id = this.customer_addresses
        ? this.customer_addresses_by_store_id(storeId)
        : []
      if (cust_addresses_by_store_id.length > 0) {
        var addr_to_select = cust_addresses_by_store_id[0]
        for (var addr of cust_addresses_by_store_id) {
          if (
            addr.location_coordinates.lat ==
              this.customerPosition.coordinates.lat &&
            addr.location_coordinates.lng ==
              this.customerPosition.coordinates.lng
          ) {
            addr_to_select = addr
          }
        }
        this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', addr_to_select)
      }
    },
    opendeliveryDropdown() {
      this.openDeliveryarea = !this.openDeliveryarea
    },
    closedeliveryDropdown() {
      this.openDeliveryarea = false
    },
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
      this.$store.commit('OPEN_MOBILE_CART')
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-button {
  cursor: pointer;
  position: relative;
  .basic-btn {
    position: relative;
    display: flex;
    border: $px1 solid $light-border;
    background-color: $white;
    padding: $px8 $px15;
    border-radius: $px46;
    .rightarrow {
      width: $px36;
      height: $px22;
      padding-left: $px30;
      margin-left: auto;
    }
    h6 {
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      text-transform: capitalize;
      letter-spacing: 0.005em;
      color: $font-color;
      margin-bottom: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      span {
        margin-left: $px5;
      }
    }
    &.dine-btn {
      h6 {
        margin-right: $px10;
      }
    }
  }
  .filter-content {
    padding: 0;
    position: fixed;
    left: 0;
    top: unset;
    bottom: -$px50;
    transform: unset;
    left: 0;
    width: 100vw;
    background-color: $white;
    box-shadow: 0px -$px6 $px30 rgba($black, 0.1);
    display: none;
    animation: fadeInUp;
    animation-duration: 0.5s;
    border-radius: $px4;
    z-index: 99;
    ::-webkit-scrollbar {
      width: $px4 !important;
    }
    ul {
      max-height: $px240;
      overflow: auto;
      margin: $px15;
      padding-right: $px5;
      li {
        // border: $px1 solid $light-border;
        // border-radius: $px4;
        // padding: $px12 $px15;
        display: block;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          background-image: url('/images/svg/global/true-w.svg');
          width: $px22;
          height: $px22;
          right: 0;
          top: 0;
          background-color: $color-primary;
          background-repeat: no-repeat;
          background-position: center;
          border-radius: 0 $px4 0 $px4;
          transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
            -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
          opacity: 0;
          transform: rotate(-45deg) scale(0, 0);
        }
        + li {
          margin-top: $px15;
        }
        &:hover {
          background-color: $transparent;
        }
        label {
          margin-bottom: 0;
          width: 100%;
          position: relative;
          cursor: pointer;
          .radio_animated {
            float: right;
            margin-right: $px6;
            margin-top: $px5;
            opacity: 0;
            &:after {
              border-radius: $px2;
              background-color: $white;
              border: none;
            }
            &:before {
              transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
              transform: rotate(-45deg) scale(0, 0);
              left: $px3;
              top: $px1;
              z-index: 1;
              width: 0.75rem;
              height: 0.375rem;
              border: $px2 solid $white;
              border-top-style: none;
              border-right-style: none;
              background: $transparent;
              border-radius: 0;
            }
            &:checked {
              opacity: 1;
              &:after {
                background-color: $color-primary;
              }
              &:before {
                transform: rotate(-45deg) scale(1, 1);
              }
              ~ span {
                border: $px2 solid $color-primary;
                transition: all 0.5s ease;
                color: $color-primary;
              }
            }
          }
          span {
            padding: calc(
              #{$px8} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            );
            border: $px2 solid $light-border;
            display: block;
            border-radius: $px4;
            transition: all 0.5s ease;
            font-weight: 600;
            font-size: calc(
              #{$px14} + (16 - 14) * ((100vw - #{$px320}) / (1920 - 320))
            );
            line-height: $px19;
            text-align: center;
            letter-spacing: 0.02em;
          }
        }
      }
    }
    .content-header {
      padding: $px20 $px16;
      border-bottom: $px1 solid $light-border;
      h6 {
        font-weight: 600;
        font-size: $px18;
        line-height: $px22;
        letter-spacing: 0.02em;
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: 0;
        span {
          font-weight: 600;
          font-size: $px18;
          line-height: $px22;
          letter-spacing: 0.02em;
          color: $light-font;
        }
      }
      .close-filter {
        margin-left: auto;
        padding-top: $px3;
      }
    }
    .content-footer {
      padding: $px15;
      border-top: $px1 solid $light-border;
      display: flex;
      text-transform: capitalize;
      letter-spacing: 0.02em;
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      text-align: center;
      .btn {
        width: 46%;
        &.ml-15 {
          margin-left: $px15;
        }
        &.btn-outline {
          color: $light-font;
          border-color: $light-font;
          &:hover {
            color: $white;
            background-color: $light-font;
          }
        }
      }
    }
    &.show {
      top: unset;
      bottom: 0;
      display: block;
    }
  }
  .mobile-overlay {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($black, 0.5);
    z-index: 5;
    transition: all 0.5s ease;
    &.show {
      display: block;
    }
  }
}
.body-rtl {
  .close-filter {
    margin-right: auto;
    margin-left: unset;
  }
}
</style>
